import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ib-icons',
  props: {
  icon: {
    type: String,
    required: true,
  },
  color: {
    type: String,
  },
  size: {
    type: [Number, String],
    default: 24
  },
  pointer: {
    type: Boolean,
    default: false
  },
},
  setup(__props) {

const props = __props;



const className = computed( () => {
  return `ib-${props.icon} ${props.pointer ? 'pointer' : ''}`
})

const colorComputed = computed( () => {
  if (props.color) {
    if (props.color === "currentColor") {
      return 'currentColor'
    }
    return `var(--${props.color})`
  }
  return ''
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["ib-icon", _unref(className)]),
    style: _normalizeStyle({
          'background-color': _unref(colorComputed),
          'min-width': `${__props.size}px`,
          'max-width': `${__props.size}px`,
          'height': `${__props.size}px`
        })
  }, null, 6))
}
}

})